export default "__VITE_ASSET__$7H6zENE__"